import { Controller } from "@hotwired/stimulus"

// The distributor dropdown's Other: picking it reveals (and enables) the
// free-text input; picking anything else hides and DISABLES it, so a
// disabled field never submits a stale Other value.
export default class extends Controller {
  static targets = ["choice", "other"]

  changed() {
    const isOther = this.choiceTarget.value === "Other"
    this.otherTarget.hidden = !isOther
    this.otherTarget.disabled = !isOther
    // Other with nothing typed would save as nothing: let the browser's
    // own field message stop the submit.
    this.otherTarget.required = isOther
    if (isOther) this.otherTarget.focus()
  }
}
